import './footer.css';
import facebook from '../../../assets/facebook.webp';
import instagram from '../../../assets/insta.webp';
import linkedin from '../../../assets/linkedin.webp';
import youtube from '../../../assets/youtube.webp';
import google from '../../../assets/googlereview.webp';
import tursilot from '../../../assets/Trustpilot.webp';
import { useEffect, useState } from 'react';
import { GET } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { MapPin, Phone, Mail } from "lucide-react";

function Footer() {
    const [isLoading, setIsLoading] = useState(false);
    const [allCategoryData, setallCategoryData] = useState<any>([]);
    const [isChatVisible, setIsChatVisible] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [chatContent, setChatContent] = useState<string[]>([
        'Hello! How can we assist you today?',

        'Type your message below to get started!',
    ]);

    // Function to toggle the message input visibility and chat content
    const toggleChat = () => {
        setIsChatVisible((prev) => !prev);
        scrollToBottom();
    };

    // Function to submit the message and redirect to WhatsApp
    const submitMessage = () => {
        if (message.trim() !== '') {
            setChatContent((prev) => [...prev, message]);
            const whatsappURL = `https://wa.me/+919778127404?text=${encodeURIComponent(message)}`;

            window.open(whatsappURL, '_blank');
            setMessage(''); // Clear input field
            scrollToBottom();
        } else {
            alert('Please type a message.');
        }
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Function to scroll the chatbox to the bottom
    const scrollToBottom = () => {
        const chatContentElement = document.getElementById('chat-content');
        if (chatContentElement) {
            chatContentElement.scrollTop = chatContentElement.scrollHeight;
        }
    };
    const categories = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CATEGORIES, {});
            setallCategoryData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        categories();
    }, []);
    const categoryOrder = ['Tax', 'Finance & Accounting', 'Auditing & Investigation'];

    const sortedCategories = allCategoryData.sort((a: any, b: any) => {
        return categoryOrder.indexOf(a.categoryTitle) - categoryOrder.indexOf(b.categoryTitle);
    });

    return (
        <div>
            <div>
                <div className="center-content-footer">Your Content Here</div>
            </div>
            <footer className="footer">
                <div className="footer-sections">
                    <div className="footer-sections-logo1">
                        <h2>Quick Links</h2>
                        <a href="/">Home</a>
                        <a href="/about-us">About Us</a>
                        <a href="/course">Courses</a>
                        <a href="/blogs">Blogs</a>
                        <a href="/contact">Contact</a>
                    </div>

                    <div >
                        <div>
                            <div className='footer-sections-contact'>
                                <h2>Categories</h2>
                                {sortedCategories.map((category: any) => (
                                    <p key={category.id}>
                                        <a href={`/course/category/${category.id}`}>{category.categoryTitle}</a>
                                    </p>
                                ))}
                            </div>
                        </div>

                        <h2 >Follow Us</h2>

                        <div className="footer-sections-social">
                            <a href="https://www.linkedin.com/company/meantoir-global-academy/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                                <img src={linkedin} className="social-icon" alt="LinkedIn" />
                            </a>
                            <a href="https://www.instagram.com/meantoir_global_academy/" target="_blank" rel="noopener noreferrer">
                                <img src={instagram} className="social-icon" alt="Instagram" />
                            </a>

                            <a href="https://www.facebook.com/Meantoir-Global-Academy-61558424812934/" target="_blank" rel="noopener noreferrer">
                                <img src={facebook} className="social-icon" alt="Facebook" style={{ width: "50px" }} />
                            </a>
                            <a href="https://youtube.com/@meantoirglobalacademy?si=Mx4uyCT9Wvicjsfv" target="_blank" rel="noopener noreferrer">
                                <img src={youtube} className="social-icon" alt="YouTube" />
                            </a>

                        </div>

                    </div>

                    <div className="footer-sections-contact" style={{ lineHeight: "1.8" }}>
                        <h2 style={{ marginBottom: "16px", fontSize: "22px", fontWeight: "600" }}>
                            Get in touch
                        </h2>

                        {/* Address */}
                        <p style={{ display: "flex", alignItems: "flex-start", gap: "10px", margin: "10px 0" }}>
                            <MapPin size={26} style={{ minWidth: "26px", marginTop: "4px" }} />
                            <span>
                                Room 103, 1st Floor, Aiswarya Building, SA Road, Valanjambalam, Kochi,
                                PIN: 682016
                            </span>
                        </p>

                        {/* Phone 1 */}
                        <p style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0" }}>
                            <Phone size={22} style={{ minWidth: "22px" }} />
                            <a
                                href="https://wa.me/919778127403"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", color: "#ffffffff" }}
                            >
                                +91-9778127403
                            </a>
                        </p>

                        {/* Phone 2 */}
                        <p style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0" }}>
                            <Phone size={22} style={{ minWidth: "22px" }} />
                            <a
                                href="https://wa.me/919778127404"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", color: "#ffffffff" }}
                            >
                                +91-9778127404
                            </a>
                        </p>

                        {/* Email */}
                        <p style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0" }}>
                            <Mail size={22} style={{ minWidth: "22px" }} />
                            <a
                                href="mailto:info@meantoir.com"
                                style={{ textDecoration: "none", color: "#ffffffff" }}
                            >
                                info@meantoir.com
                            </a>
                        </p>
                    </div>

                </div>


            </footer>
            <div className="footer-container">
                <p>&copy; 2026 Meantoir Global Academy™. All rights reserved.</p>
                <div className="footer-links">
                    <a href="/Accreditations" >
                        Accreditations & Affiliations
                    </a>
                    <a href="/privacy">Terms and Conditions</a>
                    <a href="/refund">Refund Policy</a>
                    <a href="/contact">Contact</a>
                </div>
            </div>
            <div>
                {/* WhatsApp Chat Button */}
                <div
                    style={{
                        position: 'fixed',          // Keeps it fixed on the screen
                        bottom: '80px',             // 80px from the bottom of the viewport
                        right: '10px',              // 10px from the right of the viewport
                        display: 'flex',
                        alignItems: 'center',
                        // backgroundColor: '#25d366', // WhatsApp green color

                        cursor: 'pointer',
                        zIndex: 1000                // Make sure it's on top
                    }}

                >
                    <button
                        onClick={toggleChat}
                        style={{ textDecoration: 'none', color: 'white', display: 'flex', alignItems: 'center', background: 'none', border: 'none' }}
                    >
                        <div>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                                alt="WhatsApp"
                                style={{ width: '40px', height: '40px', }}
                            />
                        </div>
                        {/* <div style={{ fontSize: '14px', fontWeight: 'bold' }}>Chat with us on WhatsApp</div> */}
                    </button>
                </div>

                {isChatVisible && (
                    <div
                        id="whatsapp-chatbox"
                        style={{
                            position: 'fixed',
                            bottom: '80px',
                            right: '10px',
                            backgroundColor: '#ffffff',
                            padding: '15px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            borderRadius: '10px',
                            zIndex: 1000,
                            width: '300px',
                        }}
                    >
                        {/* Close Button */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <strong style={{ fontSize: '16px' }}>Support Chat</strong>
                            <button
                                onClick={toggleChat}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    color: '#999',
                                }}
                                aria-label="Close chat"
                            >
                                &times;
                            </button>
                        </div>

                        {/* Chat messages */}
                        <div
                            id="chat-content"
                            style={{ marginBottom: '15px', maxHeight: '200px', overflowY: 'auto' }}
                        >
                            {chatContent.map((msg, index) => (
                                <div
                                    key={index}
                                    className="chat-message"
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#f1f1f1' : '#d4edda',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        marginBottom: '8px',
                                    }}
                                >
                                    {msg}
                                </div>
                            ))}
                        </div>

                        {/* Message input */}
                        <div style={{ display: 'flex' }}>
                            <input
                                type="text"
                                id="message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Type your message..."
                                style={{
                                    padding: '8px',
                                    width: '200px',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                    marginRight: '10px',
                                }}
                            />
                            <button
                                onClick={submitMessage}
                                style={{
                                    padding: '8px 15px',
                                    backgroundColor: '#25d366',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                }}
                            >
                                Send
                            </button>
                        </div>
                    </div>
                )}

            </div>
            <div className="top-header-bar">
                <div className="fixed-social-icons">
                    <a href="https://www.linkedin.com/company/meantoir-global-academy/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                        <img src={linkedin} className="social-icon" alt="LinkedIn" />
                    </a>
                    <a href="https://www.instagram.com/meantoir_global_academy/" target="_blank" rel="noopener noreferrer">
                        <img src={instagram} className="social-icon" alt="Instagram" />
                    </a>
                    <a href="https://www.facebook.com/Meantoir-Global-Academy-61558424812934/" target="_blank" rel="noopener noreferrer">
                        <img src={facebook} className="social-icon" alt="Facebook" style={{ height: "50px" }} />
                    </a>
                    <a href="https://youtube.com/@meantoirglobalacademy?si=Mx4uyCT9Wvicjsfv" target="_blank" rel="noopener noreferrer">
                        <img src={youtube} className="social-icon" alt="YouTube" />
                    </a>
                    <a
                        href='https://www.google.com/search?q=meantoir+global+academy&rlz=1C1PNBB_en-GBIN1096IN1096&oq=me&gs_lcrp=EgZjaHJvbWUqBggCEEUYOzIGCAAQRRg8MgYIARBFGDkyBggCEEUYOzIGCAMQRRg7MgYIBBBFGD0yBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgyOTg2ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x3b0809004b320ff5:0x584c5787e5c948f8,1,,,,'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={google} className="social-icon small-icon" alt="Google" />
                    </a>
                    <a
                        href='https://www.trustpilot.com/review/meantoir.com?utm_medium=trustbox&utm_source=TrustBoxReviewCollector'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={tursilot} className="social-icon small-icon" alt="Trustpilot" />
                    </a>
                </div>
            </div>

            <button className="scroll-to-top-btn" onClick={scrollToTop}>
                ↑
            </button>
        </div>
    );
}

export default Footer;
